﻿/// <reference path="../lib/jquery.d.ts" />

import {Controller} from "./helpers/controller";

export class PopupControlConfig {
    popupElement?: HTMLElement | undefined;
    defaultEvents?: boolean = true;
    openCallback?: () => void;
    closeCallback?: () => void;
    scrollTo?: number = 0
}

export class PopupControl extends Controller {

    private popupSelector: string = ``;
    private popupModule = () => $('');
    private popupCloseButton = () => this.popupModule().find('[data-close]');
    private pageWrap: JQuery = $('.pageWrap');
    private scrollBackTo: number;
    private config?: PopupControlConfig;
    private html: JQuery = $('html');

    constructor(element: HTMLElement, config: PopupControlConfig = new PopupControlConfig()) {
        super(element);

        this.scrollBackTo = config.scrollTo ?? 0;
        this.config = config;

        if (config.popupElement !== undefined) {
            // @ts-ignore
            this.popupModule = () => $(config.popupElement);
        } else {
            this.popupSelector = `#${$(element).data().popup}`;
            this.popupModule = () => $(this.popupSelector);
        }

        this.popupModule().hide();

        if (this.config?.defaultEvents){
            $(element).on('click', (e) => {
                e.preventDefault();
                let _this = this;

                this.open();

                if (config.openCallback != undefined) {
                    config.openCallback();
                }
            });  
        }
       
    }
    open = () =>{
        let _this = this;
        this.scrollBackTo = $(document).scrollTop()
        this.pageWrap.addClass("overlayCover");
        window.scrollTo(0, 0);
        this.popupModule().show();

        var checkPopupCloseExist = setInterval(function () {
            let popupClose = _this.popupCloseButton();
            if (popupClose.length) {
                popupClose.on('click', (e) => {
                    _this.close();
                });
                clearInterval(checkPopupCloseExist);
            }
        }, 500);
    }
    close = () => {
        this.popupModule().hide();
        this.pageWrap.removeClass("overlayCover");
        window.scrollTo(0, this.scrollBackTo);

        if (this.config?.closeCallback != undefined) {
            this.config.closeCallback();
        }
    }
}

